import { fetchExploreFeed, ResponseType } from '@/api/fetchExploreFeed'
import { fetchFollowFeed } from '@/api/fetchFollowFeed'
import { QUERY_KEY } from '@/constants/queryKey'
import { useInfiniteScroller } from '@/hooks/livemallclub/useInfiniteScroller'
import { useRouter } from 'next/router'
import { useMemberData } from './useMemberData'

export const FEED_DEFAULT_PAGE_SIZE = 20

type FeedDataQueryParamsType = {
  feedType?: 'explore' | 'follow'
}

const fetchFunction = {
  explore: fetchExploreFeed,
  follow: fetchFollowFeed,
}

const getQueryKey = (feedType: 'explore' | 'follow', preferenceTag: string) =>
  ({
    explore: [QUERY_KEY.FETCH_EXPLORE_FEED, { preferenceTag }],
    follow: [QUERY_KEY.FETCH_FOLLOW_FEED],
  }[feedType])

const getQueryOptions = (feedType: 'explore' | 'follow', isReady: boolean, isLogin: boolean, preferenceTag: string) =>
  ({
    explore: { enabled: isReady && !!preferenceTag && isLogin },
    follow: { enabled: isReady && isLogin },
  }[feedType])

const handleQueryStringConvert = (query: string | string[] | undefined) => (Array.isArray(query) ? query.join(',') : query)

export const useFeedDataQuery = ({ feedType = 'explore' }: FeedDataQueryParamsType = {}) => {
  const router = useRouter()
  const { preferenceTag: rawPreferenceTag } = router.query
  const preferenceTag = handleQueryStringConvert(rawPreferenceTag) || ''
  const fetchFunc = fetchFunction[feedType]
  const { memberData } = useMemberData()
  const isLogin = !!memberData?.memberInfoId

  const queryKey = getQueryKey(feedType, preferenceTag)
  const queryOptions = getQueryOptions(feedType, router.isReady, isLogin, preferenceTag)

  const queryFunction = async ({ pageParam }: { pageParam?: any }) => await fetchFunc({ preferenceTag, type: 'live', cursorId: pageParam?.cursorId })

  const {
    data: feedData,
    query: feedDataQuery,
    handleNextPage,
    hasNextPage,
    refetch,
    InfiniteScrollComponent,
  } = useInfiniteScroller<ResponseType>({ queryKey, queryFunction, queryOptions })

  return {
    feedData,
    feedDataQuery,
    handleNextPage,
    hasNextPage,
    refetch,
    InfiniteScrollComponent,
  }
}
